module.exports = __webpack_public_path__ + "img/game-login.308ed136.webp";